import { ReusablePaymentMethod } from '@platform-frontend/marketplace';
import { WalletPaymentData } from './wallet-payment-data';

export type PaymentInformation = ReusablePaymentMethod | WalletPaymentData;
